/// <reference path="../services/security.service.ts" />
import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { SecurityService } from '../services/security.service';
@Directive({
  selector: '[hasAccessRight]'
})
export class HasAdditionalAccessRightDirective {
    private el: HTMLElement;
    @Input() set hasAccessRight(claim: number) {
        if (this.hasAdditionalAccessRight(claim))
            this.viewContainer.createEmbeddedView(this.templateRef)
        else
            this.viewContainer.clear();
    }

    constructor(private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private _securityService: SecurityService) { }

    hasAdditionalAccessRight(additionalAccessRightID: number): boolean {
        return this._securityService.hasAdditionalAccessRight(additionalAccessRightID);
        //let additionalAccessRightList: number[] = JSON.parse(localStorage.getItem('accessRights'));

        //if (additionalAccessRightList && additionalAccessRightList.length && (additionalAccessRightList.filter(x => x == additionalAccessRightID)[0] != null))
        //    return true;
        //return false;
    }
}
